export default {
  meta: {
    title: '采购单管理'
  }
};
